import { render, staticRenderFns } from "./BrowseToFileSettings.vue?vue&type=template&id=646c1ec9&scoped=true"
import script from "./BrowseToFileSettings.vue?vue&type=script&lang=ts"
export * from "./BrowseToFileSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c1ec9",
  null
  
)

export default component.exports